import AppSettings from "../configs/appSettings";

export default class Constants {
  
  public static QueryParameterNames = {
    ReturnUrl: "returnUrl",
    Message: "message",
  };

  public static LogoutActions = {
    LogoutCallback: "logout-callback",
    Logout: "logout",
    LoggedOut: "logged-out",
  };

  public static LoginActions = {
    Login: "login",
    LoginCallback: "login-callback",
    LoginFailed: "login-failed",
  };

  private static prefix = "/oauth";

  public static ApplicationPaths = {
    AuthorizationPrefix: this.prefix,
    Login: `${this.prefix}/${this.LoginActions.Login}`,
    LoginFailed: `${this.prefix}/${this.LoginActions.LoginFailed}`,
    LoginCallback: `${this.prefix}/${this.LoginActions.LoginCallback}`,
    LogOut: `${this.prefix}/${this.LogoutActions.Logout}`,
    LoggedOut: "/",
    LogOutCallback: `${this.prefix}/${this.LogoutActions.LogoutCallback}`,
    Profile: `${AppSettings.SSOAuthority}/Identity/Account/Manage`,
    AccessDeny: `${this.prefix}/AccessDeny`,
    Ratelimit: `/Ratelimit`,
  };

  public static OAuthOptions = {
    ClientScope: "openid profile Kimball",
    ClientId: "Datavault",
  };

  public static MaxProductsCompared: number = 5;

  public static ApiPath = {
    CategoryPage: 'api/categories',
    ProductCompare: 'api/products/compare',
    ProductSearch: 'api/products/search',
    DocumentPage: 'api/documents',
    DocumentDownload: 'api/documents/download',
    DocumentGenerate: 'api/documents/generate',
    BuildNumber: 'api/utility/buildNumber'
  };

  public static PageSize = 20;

}
